import { ValueType } from "consts/setups";
import { JsonAssoc, JsonAssocSetupValue } from "./JsonAssoc";
import {
    Csv,
    CsvInt,
    CsvHour,
    CsvSetupValue,
    CsvCountry,
    CsvCurrency,
    CsvSftpFolder
} from "./Csv";
import { String, StringSetupValue } from "./String";
import { Int, IntSetupValue } from "./Int";
import { Boolean, BooleanSetupValue } from "./Boolean";
import { DateTime, DateTimeSetupValue } from './DateTime';

export const registry = new Map()
    .set(ValueType.JsonAssoc, [JsonAssoc, JsonAssocSetupValue])
    .set(ValueType.JsonList, [JsonAssoc, JsonAssocSetupValue])
    .set(ValueType.Csv, [Csv, CsvSetupValue])
    .set(ValueType.CsvSftpFolder, [CsvSftpFolder, CsvSetupValue])
    .set(ValueType.CsvInt, [CsvInt, CsvSetupValue])
    .set(ValueType.CsvHour, [CsvHour, CsvSetupValue])
    .set(ValueType.CsvCountry, [CsvCountry, CsvSetupValue])
    .set(ValueType.CsvCurrency, [CsvCurrency, CsvSetupValue])
    .set(ValueType.String, [String, StringSetupValue])
    .set(ValueType.Int, [Int, IntSetupValue])
    .set(ValueType.Boolean, [Boolean, BooleanSetupValue])
    .set(ValueType.DateTime, [DateTime, DateTimeSetupValue]);

export default registry;
